import { register } from "@rill/loader";
import { isAfterToday } from "../utils/date-helpers";

register(
  {
    name: "dayPersonalRecords",
    meta: ["no-bust", "exercise"],
    ttl: "2 hours",
  },
  async ({ api }, { start, end, proxyAthlete, isCheckIn }) => {
    const query = {
      start,
      end,
      isCheckIn,
    };
    if (proxyAthlete) {
      query.proxyAthlete = proxyAthlete;
    }

    if (isAfterToday(end)) return {};

    const res = await api("personal-records", { query });
    const parsedRes = await res.json();
    return parsedRes;
  }
);
